import { getImageUrl } from "@faedev/editor-utils";
import constants from "src/constants";
import getOg from "src/functions/getOg";
import translate from "src/functions/translate";

function getDefaultOg(lang: string) {
  return getOg(
    lang,
    `website`,
    translate(constants.Marketing.ogTitle, lang),
    translate(constants.Marketing.ogDescription, lang),
    (function () {
      switch (lang) {
        case `cs`:
          return (
            constants.Paths.appUrl +
            getImageUrl("/images/social/vivido-social-app-cs.jpg")
          );
        case `sk`:
          return (
            constants.Paths.appUrl +
            getImageUrl("/images/social/vivido-social-app-sk.jpg")
          );
        default:
          return (
            constants.Paths.appUrl +
            getImageUrl("/images/social/vivido-social-app-en.jpg")
          );
      }
    })()
  );
}

export default getDefaultOg;
